const base = {
  user: {
    route: 'user',
    title: 'Usuários',
    headers: [
      { title: 'ID', field: 'id', width: '160px' },
      { title: 'Nome', field: 'name' },
      { title: 'E-mail', field: 'email' },
    ],
    filters: [],
  },
  group: {
    route: 'group',
    title: 'Grupos',
    headers: [
      { title: 'ID', field: 'id', width: '160px' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  screen: {
    route: 'screen',
    title: 'Programas',
    simpleSearch: true,
    headers: [
      { title: 'ID', field: 'id', width: '120px' },
      { title: 'Nome', field: 'name' },
      { title: 'Rota', field: 'screenRoute' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Rota',
        param: 'screenRoute',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite a rota',
      },
    ],
  },
  jiraUser: {
    route: 'jira/users',
    title: 'Usuários Jira',
    simpleSearch: true,
    headers: [
      { title: 'Account ID', field: 'accountId' },
      { title: 'Nome', field: 'displayName' },
      { title: 'E-mail', field: 'email' },
    ],
    filters: [],
  },
  githubUser: {
    route: 'github/users',
    title: 'Usuários GitHub',
    simpleSearch: true,
    headers: [
      { title: 'Login', field: 'login' },
      { title: 'Nome', field: 'displayName' },
    ],
    filters: [],
  },
  githubRepository: {
    route: 'github/repositories',
    title: 'Repositórios GitHub',
    simpleSearch: true,
    headers: [
      { title: 'Repositório', field: 'fullName' },
      { title: 'Branch padrão', field: 'defaultBranch' },
    ],
    filters: [],
  },
}

export default base
